"use client"

import { useQuery } from "@tanstack/react-query"

import {
  getAdminSignupOnboardingDetailsAction,
  getAdminSignupOnboardingSummariesAction,
} from "@/server-actions/admin-signup-onboarding"
import { useTranslations } from "next-intl"


export const adminSignupOnboardingQueryKey = [
  "admin",
  "signup-onboarding",
] as const

export function useAdminSignupOnboardingSummariesQuery(enabled: boolean) {
  return useQuery({
    queryKey: [...adminSignupOnboardingQueryKey, "summaries"],
    enabled,
    queryFn: async () => {
      const result = await getAdminSignupOnboardingSummariesAction({})
      if ("status" in result) throw new Error(result.errorMessage)
      return result
    },
  })
}

export function useAdminSignupOnboardingDetailsQuery(
  tenantId: string | null,
) {
  const tUi = useTranslations("Feedback.QueriesAdminSignupOnboarding")

  return useQuery({
    queryKey: [...adminSignupOnboardingQueryKey, "details", tenantId],
    enabled: Boolean(tenantId),
    queryFn: async () => {
      if (!tenantId) throw new Error(tUi("tenantIsRequired"))
      const result = await getAdminSignupOnboardingDetailsAction({
        tenant_id: tenantId,
      })
      if ("status" in result) throw new Error(result.errorMessage)
      return result
    },
  })
}
